import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "base-search" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import { baseInput, baseLoading } from "@/common/components";

interface OptionsType {
	id: string;
	label: string;
	value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'base-search',
  props: {
    label: {},
    placeholder: {},
    search: {},
    searched: { type: Boolean },
    loading: { type: Boolean },
    disabled: { type: Boolean },
    optionLabel: { default: "label" },
    options: {}
  },
  emits: ["search", "select", "clear"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const searchInput = ref("");

function search() {
	// if (searchInput.value.trim().length === 0) {
	//   emit("clear");
	//   return;
	// }

	emit("search", searchInput.value);
}

function selectOption(option: OptionsType) {
	searchInput.value = option[props.optionLabel];

	emit("select", option);
}

const debounced = debounce(search, 600);

watch(
	() => props.search,
	() => {
		searchInput.value = props.search;
	},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: searchInput.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
      value: searchInput.value,
      placeholder: props.placeholder,
      disabled: __props.disabled,
      onInput: _unref(debounced)
    }, _createSlots({ _: 2 }, [
      (props.label)
        ? {
            name: "label",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.label), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "value", "placeholder", "disabled", "onInput"]),
    (props.searched)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(["options shadow", {
					empty: props.options.length === 0,
					loading: props.loading,
				}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (selectOption(option))
            }, _toDisplayString(option[props.optionLabel]), 9, _hoisted_2))
          }), 128)),
          (props.options.length === 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_unref(t)("common.texts.no_results")), 1))
            : _createCommentVNode("", true),
          (props.loading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createVNode(_unref(baseLoading))
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})